import { useEffect, useState } from "react";
import { getConsent, acceptConsent, declineConsent } from "@/lib/analytics";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === null) setVisible(true);
  }, []);

  const accept = () => {
    acceptConsent();
    setVisible(false);
  };

  const decline = () => {
    declineConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="consent-banner"
      role="dialog"
      aria-label="Cookie and analytics consent"
      className="fixed bottom-0 inset-x-0 z-[200] border-t border-[#FF6B00]/30 bg-[#0a0a0a]/97 backdrop-blur-md px-6 py-5 md:px-10"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-4 md:gap-6">
        <p className="text-sm text-white/70 leading-relaxed flex-1">
          We use cookies and analytics (Google Analytics, PostHog) to understand
          site traffic and improve Pickle Wall™. We never track passwords,
          payment details, or personal messages.{" "}
          <a href="/privacy-policy" className="text-[#FF6B00] underline underline-offset-2">
            Learn more
          </a>
          .
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={decline}
            data-testid="consent-decline"
            className="px-5 py-2.5 text-xs font-bold uppercase tracking-wider text-white/60 hover:text-white border border-white/15 rounded-full transition-colors"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={accept}
            data-testid="consent-accept"
            className="px-5 py-2.5 text-xs font-bold uppercase tracking-wider bg-[#FF6B00] hover:bg-[#E66000] text-black rounded-full transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
